import React from 'react';
import { Box, Button, Paper, Typography } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import { FormattedMessage } from 'react-intl';

/**
 * Maps HTTP / parse outcomes from certHistory load to a user-facing message id.
 * @param {number|string|null} errorStatus
 * @returns {string}
 */
export const getCertLoadErrorMessageId = (errorStatus) => {
  if (errorStatus === 404) return 'noPatient';
  if (errorStatus === 401 || errorStatus === 403) return 'authError';
  if (errorStatus === 200 || errorStatus === 204) return 'certNoData';
  if (typeof errorStatus === 'number' && errorStatus >= 500) {
    return 'certServerError';
  }
  return 'certLoadError';
};

/**
 * Centered card for failed patient certHistory load (replaces window.alert).
 * Intended for the listing fullscreen transparent Dialog shell.
 */
const CertLoadError = ({ errorStatus, onRetry, onClose, showClose }) => {
  const messageId = getCertLoadErrorMessageId(errorStatus);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      width="100%"
      p={2}
      role="alert"
      boxSizing="border-box"
    >
      <Paper
        elevation={8}
        style={{ maxWidth: 480, width: '100%', padding: 24 }}
      >
        <Alert severity="error" variant="outlined">
          <AlertTitle>
            <FormattedMessage id="certLoadErrorTitle" />
          </AlertTitle>
          <Typography variant="body2" component="p">
            <FormattedMessage id={messageId} />
          </Typography>
        </Alert>
        <Box mt={2} display="flex" justifyContent="flex-end">
          {typeof onRetry === 'function' && (
            <Button
              color="primary"
              variant="outlined"
              onClick={onRetry}
              style={{ marginRight: 8 }}
            >
              <FormattedMessage id="certLoadErrorRetry" />
            </Button>
          )}
          {showClose && typeof onClose === 'function' && (
            <Button color="primary" variant="contained" onClick={onClose}>
              <FormattedMessage id="certLoadErrorClose" />
            </Button>
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default CertLoadError;
